export var borders = {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '5px'
};
